/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-14 10:11:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-21 17:08:32
 */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Row,
  Select,
} from 'antd'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useEffect, useState } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'
import moment from 'moment'
import {
  getEAFRegisterSubmitAsync,
  getEAFRegisterDetailAsync,
} from './EAFRegisterSlice'
import {
  DateTimeFormat,
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnly,
} from '../../../models/datetime'
import { getUserList } from '../../user/userSlice'

const { Option } = Select

export const AddOrEditFormModal = (props: {
  editTenantId?: any
  isEdit?: any
  id?: any
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [userList, setUserList] = useState<any>()

  const [detail, setDetail] = useState<any>()

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 15 },
  }

  const getDetail = () => {
    dispatch(
      getEAFRegisterDetailAsync({
        id: props?.id,
        tenantId: props?.editTenantId,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        setDetail(v)
        // const flag = userList
        form.setFieldsValue({
          ...v,
          quantity: v?.quantity == -1 ? '' : v?.quantity,
          price: v?.price == -1 ? '' : v?.price,
          serviceLife: v?.serviceLife == -1 ? '' : v?.serviceLife,
          amount: v?.amount == -1 ? '' : v?.amount,
          maintenanceUserId: undefined,
          administratorId: undefined,
          productionDate: v?.productionDate ? moment(v?.productionDate) : '',
          purchaseDate: v?.purchaseDate ? moment(v?.purchaseDate) : '',
          scrapDate: v?.scrapDate ? moment(v?.scrapDate) : '',
          startDate: v?.startDate ? moment(v?.startDate) : '',
        })
        dispatch(getUserList({ current: 1, size: 1000, state: 1 }))
          .then(unwrapResult)
          .then((res: any) => {
            setUserList(res?.items)

            const maintenanceUserId = res.items?.find(
              (val: any) => val?.id == v?.maintenanceUserId
            )

            const administratorId = res.items?.find(
              (val: any) => val?.id == v?.administratorId
            )

            form.setFieldsValue({
              maintenanceUserId:
                maintenanceUserId != undefined
                  ? v?.maintenanceUserId?.toString()
                  : undefined,
              administratorId:
                administratorId != undefined
                  ? v?.administratorId?.toString()
                  : undefined,
            })
          })
      })
  }

  useEffect(() => {
    if (props.isModalVisible) {
      if (props?.id) {
        getDetail()
      } else {
        getUserData()
      }
    } else {
      form.resetFields()
      setUserList([])
      setDetail({})
    }
  }, [props.isModalVisible, props?.id])

  const getUserData = () => {
    dispatch(getUserList({ current: 1, size: 1000, state: 1 }))
      .then(unwrapResult)
      .then((res: any) => {
        setUserList(res?.items)
      })
  }

  return (
    <>
      <Modal
        width={1200}
        title={
          props?.isEdit == '0'
            ? '查看详情'
            : props?.id
            ? '编辑数据'
            : '添加数据'
        }
        visible={props.isModalVisible}
        footer={null}
        maskClosable={false}
        destroyOnClose={false}
        onCancel={() => {
          props.onCancel()
        }}
        onOk={() => {
          props?.onOk()
        }}
      >
        <Form
          autoComplete='off'
          form={form}
          onFinish={(vs) => {
            setConfirmLoading(true)
            const maintenanceUserName = userList?.find(
              (v: any) => v?.id == vs?.maintenanceUserId
            )?.name

            const administratorName = userList?.find(
              (v: any) => v?.id == vs?.administratorId
            )?.name

            const productionDate = vs?.productionDate
              ? moment(vs?.productionDate)?.format(DateTimeFormat)
              : ''

            const purchaseDate = vs?.purchaseDate
              ? moment(vs?.purchaseDate)?.format(DateTimeFormat)
              : ''

            const scrapDate = vs?.scrapDate
              ? moment(vs?.scrapDate)?.format(DateTimeFormat)
              : ''

            const startDate = vs?.startDate
              ? moment(vs?.startDate)?.format(DateTimeFormat)
              : ''

            const commonParam = {
              productionDate: productionDate,
              purchaseDate: purchaseDate,
              scrapDate: scrapDate,
              startDate: startDate,
              maintenanceUser: maintenanceUserName,
              administrator: administratorName,
            }
            const params = props?.id
              ? {
                  ...vs,
                  ...commonParam,
                  id: detail?.id,
                }
              : {
                  ...vs,
                  ...commonParam,
                }
            dispatch(getEAFRegisterSubmitAsync({ ...params }))
              .then(unwrapResult)
              .then((v: any) => {
                notification.success({
                  message: '操作成功',
                })
              })
              .finally(() => {
                props?.onOk()
                setConfirmLoading(false)
              })
          }}
        >
          <Row>
            <Col span={8}>
              <Form.Item {...layout} label='配置地点' name='location'>
                <Input placeholder='配置地点' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='设备编号'
                name='deviceNumber'
                rules={[
                  {
                    required: true,
                    message: '设备编号不能为空',
                  },
                  { max: 120, message: '最长120位' },
                ]}
              >
                <Input placeholder='设备编号' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='设备名称'
                name='deviceName'
                rules={[
                  {
                    required: true,
                    message: '设备名称不能为空',
                  },
                ]}
              >
                <Input placeholder='设备名称' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='规格型号'
                name='model'
                rules={[{ max: 120, message: '最长120位' }]}
              >
                <Input placeholder='规格型号' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='出厂批号/编号'
                name='factoryNumber'
                rules={[{ max: 120, message: '最长120位' }]}
              >
                <Input placeholder='出厂批号/编号' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='生产日期' name='productionDate'>
                <DatePicker
                  style={{ width: '100%' }}
                  placeholder='生产日期'
                  format={DateTimeFormatSimple}
                  onChange={() => {
                    return
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='购置日期'
                name='purchaseDate'
                rules={[
                  {
                    required: true,
                    message: '购置日期不能为空',
                  },
                ]}
              >
                <DatePicker
                  style={{ width: '100%' }}
                  placeholder='购置日期'
                  format={DateTimeFormatSimple}
                  onChange={() => {
                    return
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='报废日期' name='scrapDate'>
                <DatePicker
                  style={{ width: '100%' }}
                  placeholder='报废日期'
                  format={DateTimeFormatSimple}
                  onChange={() => {
                    return
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='启用日期' name='startDate'>
                <DatePicker
                  style={{ width: '100%' }}
                  placeholder='启用日期'
                  format={DateTimeFormatSimple}
                  onChange={() => {
                    return
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='厂家' name='factoryName'>
                <Input placeholder='厂家' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='供货企业' name='supplierEnterprise'>
                <Input placeholder='供货企业' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='联系人' name='contactPerson'>
                <Input placeholder='联系人' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='联系电话'
                name='contactPhone'
                rules={[
                  {
                    pattern: /^(?=[0-9-]{5,20})[0-9]*-?[0-9]*-?[0-9]*$/,
                    message: '请输入正确的联系电话',
                  },
                ]}
              >
                <Input placeholder='联系电话' maxLength={13} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='数量'
                name='quantity'
                rules={[
                  {
                    message: '请输入最多带两位小数的数值',
                    pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                  },
                ]}
              >
                <Input placeholder='数量' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='价格'
                name='price'
                rules={[
                  {
                    message: '请输入最多带两位小数的数值',
                    pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                  },
                ]}
              >
                <Input placeholder='价格' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='金额'
                name='amount'
                rules={[
                  {
                    message: '请输入最多带两位小数的数值',
                    pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                  },
                ]}
              >
                <Input placeholder='金额' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='生产许可证号'
                name='productionLicenseNumber'
                rules={[{ max: 120, message: '最长120位' }]}
              >
                <Input placeholder='生产许可证号' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='注册证号'
                name='registrationCertificateNumber'
                rules={[{ max: 120, message: '最长120位' }]}
              >
                <Input placeholder='注册证号' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='执行标准号'
                name='executionStandardNumber'
              >
                <Input placeholder='执行标准号' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='养护使用人'
                name='maintenanceUserId'
              >
                <Select placeholder='养护使用人' allowClear>
                  {userList?.map((v: any, i: any) => {
                    return (
                      <Option value={v?.id} key={i}>
                        {v?.name}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='管理员' name='administratorId'>
                <Select placeholder='管理员' allowClear>
                  {userList?.map((v: any, i: any) => {
                    return (
                      <Option value={v?.id} key={i}>
                        {v?.name}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='一般检定周期'
                name='generalInspectionCycle'
              >
                <Input placeholder='一般检定周期' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='强检周期'
                name='mandatoryInspectionCycle'
              >
                <Input placeholder='强检周期' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='用途' name='usage'>
                <Input placeholder='用途' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                {...layout}
                label='使用年限'
                name='serviceLife'
                rules={[
                  {
                    pattern: /[1-9]\d*$/,
                    message: '请输入大于0的整数',
                  },
                ]}
              >
                <Input placeholder='使用年限' />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...layout} label='备注' name='remark'>
                <Input placeholder='备注' />
              </Form.Item>
            </Col>
          </Row>
          {props?.isEdit == '0' ? (
            <></>
          ) : (
            <Row
              style={{
                marginTop: '20px',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Button
                loading={confirmLoading}
                type='primary'
                onClick={() => {
                  form.submit()
                }}
                style={{ marginRight: '10px' }}
              >
                确定
              </Button>
              <Button
                type='primary'
                ghost
                style={{ marginRight: '10px' }}
                onClick={() => {
                  props?.onCancel()
                }}
              >
                取消
              </Button>
            </Row>
          )}
        </Form>
      </Modal>
    </>
  )
}
